import React from "react";

interface SpinnerProps {
  text?: string;
}

const Spinner = ({ text = "Loading..." }: SpinnerProps) => {
  return (
    <div className="overlay-spinner" aria-live="polite" aria-label="Loading">
      <div className="spinner-wrapper">
        <div className="spinner" />
        <p className="spinner-text">{text}</p>
      </div>
    </div>
  );
};

export default Spinner;
